/* eslint-disable no-undef */

const TAG = 'Omnisend';

const OmnisendScript = {
  pageView() {
    try {
      window.omnisend.push(['track', '$pageViewed']);
    } catch (e) {
      console.log(TAG, 'pageView', e);
    }
  },
};

export default OmnisendScript;
